module.exports = __webpack_public_path__ + "static/media/CRABAPPLE.df93306e.JPG";